<template>
  <div>
    <v-row class="mt-4">
      <v-col cols="10">
        <v-row>
          <v-col cols="6" class="py-0">
            <v-label> Column Name </v-label>
            <TextFieldComponent
              :showReadOnly="showReadOnly"
              variant="outlined"
              v-model="formDatas.column_name"
              density="compact"
            ></TextFieldComponent>
          </v-col>
          <v-col cols="6" class="py-0">
            <v-label> Label Name </v-label>
            <TextFieldComponent
              variant="outlined"
              v-model="formDatas.label"
              :showReadOnly="showReadOnly"
              density="compact"
            ></TextFieldComponent>
          </v-col>
          <v-col cols="6" class="py-0 pb-3">
            <v-label> Data type </v-label>
            <EnumAutoComplete
              class="dropdown"
              density="compact"
              :selected="formDatas.data_type"
              :domain="'DATA-TYPE'"
              :showReadOnly="showReadOnly"
              placeholder="Data Type"
              @changeEnumData="changeTitle($event)"
            ></EnumAutoComplete
          ></v-col>
          <v-col cols="6" align-self="center" class="py-0 pt-3">
            <v-switch
              :disabled="showReadOnly"
              label="Column Required"
              color="primary"
              v-model="formDatas.column_required"
            ></v-switch>
          </v-col>
          <v-col cols="6" class="py-0" v-if="formDatas.column_required">
            <v-label>Table Sequence</v-label>
            <TextFieldComponent
              placeholder="Table Sequence"
              v-model="formDatas.table_sequence"
              :showReadOnly="showReadOnly"
            />
          </v-col>
          <!-- <v-col cols="3" class="py-0">
            <v-label>Model(L)</v-label>
            <AutoComplete
              placeholder="Value"
              @update:modelValue="(value) => getModelColumnData(value)"
              :name="'name'"
              :showReadOnly="showReadOnly"
              :value="'id'"
              :items="savedModelData"
            />
          </v-col>
          <v-col cols="3" class="py-0">
            <v-label>Column Name(L)</v-label>
            <AutoComplete
              placeholder="name"
              :name="'label'"
              :showReadOnly="showReadOnly"
              :value="'column_name'"
              :items="tableColumnData"
            />
          </v-col> -->
          <!-- <v-col cols="12" class="py-0">
            <div class="d-flex">
              <v-switch
                :disabled="showReadOnly"
                v-model="formDatas.computedfield"
                color="primary"
                label="Computed Field "
              />
            </div>
          </v-col> -->
          <v-col v-if="formDatas.computedfield" cols="12" class="py-0">
            <v-label> Computed Expression </v-label>
            <v-row>
              <v-col cols="11">
                <v-textarea
                  outlined
                  v-model="computed.exprssion_json"
                ></v-textarea>
              </v-col>
              <v-col cols="1">
                <v-icon
                  :disabled="showReadOnly"
                  style="cursor: pointer"
                  :size="22"
                  @click="handleClick"
                  class=""
                  >mdi mdi-table-large-plus</v-icon
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog width="85%" v-model="openRule" scrollable>
      <v-card class="card">
        <v-card-item>
          <v-card-title
            ><b>{{ expression_type }}</b>
            <Button
              boxIcon="mdi-close"
              text
              class="float-right"
              @click="openRule = false,openDialog = false"
            />
          </v-card-title>
        </v-card-item>
        <v-card-text>
          <ConditionMain
            @handleSave="closeDialog"
            :expression_type="expression_type"
            :ruleId="idsValue"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- <v-dialog width="40%" v-model="openDialog" scrollable>
      <v-card class="card">
        <v-card-item>
          <v-card-title
            ><b>Choose Builder</b>
            <Button
              boxIcon="mdi-close"
              text
              class="float-right"
              @click="openDialog = false"
            />
          </v-card-title>
        </v-card-item>
        <v-card-text>
          <ConditionSelect @handleSave="selectedRule" />
        </v-card-text>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
// import Color from "vuetify/directives/color";
// import { EnumLookUp } from "@tiburadev/enums";
import EnumAutoComplete from "@/components/others/EnumAutoComplete.vue";
import { TextFieldComponent, Button } from "@tiburadev/vue-comp3";
// import AutoComplete from "@/components/ui/AutoComplete.vue";
// import { ConditionMain } from "@tiburadev/condition-mapper";
// import dataModelDetailService from "../../api/service/DataModelDetails/DataModelsDetailsService";
// import dataModelService from "../api/service/data-models-service";
// import ConditionSelect from "./ConditionSelect.vue";

export default {
  name: "Details",
  components: {
    // EnumLookUp,
    TextFieldComponent,
    // AutoComplete,
    EnumAutoComplete,
    Button,
    // ConditionMain,
    // ConditionSelect
  },
  props: {
    formData: {
      type: Object,
      default: () => ({}),
    },
    showReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDialog: false,
      computed: {},
      idsValue: null,
      expression_type: "",
      openRule: false,
      tableColumnData: [],
      savedModelData: [],
      enabled: false,
      formDatas: {},
    };
  },
  watch: {
    formData: {
      handler() {
        // if (
        //   this.formData &&
        //   this.formData.computed_expression
        // ) {
        //   this.computed.exprssion_json = this.formData.computed_expression.exprssion_json
        //   this.idsValue = this.formData && this.formData.computed_expression ? this.formData.computed_expression.condition_id : null
        // }
        if(this.formData){
          this.formDatas = this.formData
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // this.getModelData();
  },
  methods: {
    changeTitle($event) {
      console.log($event,"$event")
        this.formDatas.data_type = $event;
    },
    selectedRule(value) {
      this.expression_type = value;
      this.openRule = true;
    },
    // async getModelColumnData(value) {
    //   let res = await dataModelDetailService.findAll({ model_id: value });
    //   this.tableColumnData = res.length > 0 ? res : [];
    // },
    // async getModelData(value) {
    //   let res = await dataModelService.findAll({ deleted: 0 });
    //   this.savedModelData = res.length > 0 ? res : [];
    // },
    handleClick() {
      this.openDialog = true;
    },
    closeDialog(value) {
      if (value) {
        this.computed.condition_id = value.id;
        this.computed.exprssion_json = value.compiled_expression;
      }
      // this.formData.computed_expression = this.computed
      this.openRule = false;
      this.openDialog = false;
    }
  }
};
</script>
<style scoped>
 .v-card {
  box-shadow: inherit !important;
  border: 1px solid #e9eaeb;
  border-radius: 12px !important;
}
/* 
>>> .v-text-field .v-field--no-label input,
.v-text-field .v-field--active input {
  background: #ebedf1;
  border-radius: 4px !important;
}

>>> .v-text-field .v-field {
  box-shadow: inherit !important;
}

>>> .v-textarea .v-field__field {
  background: #ebedf1;
  border-radius: 4px !important;
  height: 200px;
}  */
.lookup .v-input--density-default {
  --v-input-control-height: 22px !important;
  --v-input-padding-top: 0px !important;
}
.lookup .v-field__field .v-field__input{
  padding-bottom: 0px !important;
}
</style>
